import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.FollowersHistoryView extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'followers-history'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/followers_history"]

  render: ->
    @$el.html(@template({ subtitle: @getTemplateOptions().subtitle }))
    @addFollowersHistoryChart()
    return this

  addFollowersHistoryChart: ->
    twitterUserName = @getTemplateOptions().page
    data = {
      date_from_ISO: @options.fromISO.toISOString()
      date_to_ISO: @options.toISO.toISOString()
      page: twitterUserName
    }
    $.post(@options.chartApi.followers_history, data, (response) =>
      @lineGraph('#followers_history', '@' + twitterUserName, response)
      @trigger('sectionReady')
    )

  # Copied and adapted from _common.html.erb

  lineGraph: (selector, name, seriesHash, graphType, stacking) ->
    axis = @getKeys(seriesHash);
    $(selector).highcharts(
      chart:
        type: graphType || 'line'
        backgroundColor: null
      title:
        text: null
      xAxis: [{
        type: 'datetime'
        labels:
          rotation: -90
        tickInterval: @tickInterval()
        dateTimeLabelFormats:
          day: '%d/%m/%Y'
      }],
      yAxis: [
        { title: { text: axis[0] } }
        { title: { text: axis[0] }, opposite: true }
      ],
      plotOptions:
        area:
          stacking: stacking
      tooltip:
        shared: true
      series: @generateSeries(seriesHash)
    )

  generateSeries: (hash) ->
    _.map(hash, (v,k) =>
      { name: @getKey(v,k), data: @getValue(v,k) }
    )

  getKeys: (hash) ->
    return _.map(hash, @getKey)

  getKey: (v,k) ->
    return k.titleize()

  getValue: (v,k) ->
    if(v.length) #is an array?
      return _.map(v, (pair) ->
        return [ Date.parse(pair[0]), pair[1] ]
      )
    else
      return v

  tickInterval: ->
    unit = 'day'
    switch unit
      when 'month' then days = 30
      when 'week' then days = 7
      else days = 1
    return days*24*60*60*1000

  datetimeFormat = {
     day: '%d/%m/%Y'
  }
